import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment from 'moment';

@Component({
  selector: 'app-opening-balance-post',
  templateUrl: './opening-balance-post.component.html',
  styleUrls: ['./opening-balance-post.component.css']
})
export class OpeningBalancePostComponent implements OnInit {
  constructor(private accService: AccountingService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }

  PaymentModelSearch = {
    AccID: 0,
    FromDate: moment(Date.now()).format("DD-MMM-YYYY"),
    ToDate: moment(Date.now()).format("DD-MMM-YYYY"),
    Print: "",
    IsOpening: true,
  };

  PrintTrialbalanceReport() {
    this.PaymentModelSearch.FromDate = this.PaymentModelSearch.FromDate != null && this.PaymentModelSearch.FromDate != '' ? moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY') : '';
    this.PaymentModelSearch.ToDate = this.PaymentModelSearch.ToDate != null && this.PaymentModelSearch.ToDate!='' ? moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY') : '';
  
    var url = "trialbalancereportprint?PrintType=TrialbalanceReport&FromDate=" + this.PaymentModelSearch.FromDate + "&ToDate=" + this.PaymentModelSearch.ToDate+ "&AccID=" + this.PaymentModelSearch.AccID + "&IsOpening=" + this.PaymentModelSearch.IsOpening;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
  };
  SearchBankAccName = '';
  ClearSearch() {
    this.PaymentModelSearch.AccID = 0;
    this.PaymentModelSearch.FromDate = moment(Date.now()).format("DD-MMM-YYYY");
    this.PaymentModelSearch.ToDate = moment(Date.now()).format("DD-MMM-YYYY");
    this.SearchBankAccName = '';
    this.PaymentModelSearch.IsOpening = true
  };
  loadingSearch = false;
  AccountList: any;
  TotalCreditClosing = 0;
  TotalDebitClosing = 0;
  TotalCreditOpening = 0;
  TotalDebitOpening = 0;
  AccList:any;
  GetOpeningBalancePost() {

    this.loadingSearch = true;
    this.spinnerService.show();
    this.PaymentModelSearch.FromDate = this.PaymentModelSearch.FromDate != null && this.PaymentModelSearch.FromDate != '' ? moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY') : '';
    this.PaymentModelSearch.ToDate = this.PaymentModelSearch.ToDate != null && this.PaymentModelSearch.ToDate!='' ? moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY') : '';
  
    this.accService.GetOpeningBalancePost(JSON.stringify(this.PaymentModelSearch)).subscribe((response) => {
      this.AccountList = response.AccountList;
      this.BranchDetails=response.BranchDetails;
      this.AccList=response.AccList;
      var DebitClosingAmount = 0;
      var CreditClosingAmount = 0;
      var DebitOpeningBalance = 0;
      var CreditOpeningBalance = 0;
   
      if (this.AccountList != null && this.AccountList.length > 0) {

        for (var i = 0; i < this.AccountList.length; i++) {
          DebitOpeningBalance = DebitOpeningBalance + this.AccountList[i].DebitOpeningBalance;
          CreditOpeningBalance = CreditOpeningBalance + this.AccountList[i].CreditOpeningBalance;
          DebitClosingAmount = DebitClosingAmount + this.AccountList[i].DebitClosingAmount;
          CreditClosingAmount = CreditClosingAmount + this.AccountList[i].CreditClosingAmount;
         
        }
        this.GetSession();
      }

      this.TotalCreditClosing = CreditClosingAmount;
      this.TotalDebitClosing = DebitClosingAmount;
      this.TotalCreditOpening = CreditOpeningBalance;
      this.TotalDebitOpening = DebitOpeningBalance;


      setTimeout(() => {
        this.spinnerService.hide();
        this.loadingSearch = false;
        this.globalHelper.CheckActionStatus(response);
      }, 10);
    });
  };
  PaymentModel={
    SessionID:0,
  }
  SaveOpeningBalancePost() {
    
   this.spinnerService.show();
  
    this.accService.SaveOpeningBalancePost(JSON.stringify(this.AccList),JSON.stringify(this.PaymentModel)).subscribe((response) => {
      
      setTimeout(() => {
        this.spinnerService.hide();        
        this.globalHelper.CheckActionStatus(response);
      }, 10);
    });
  };







  FilePath: any;
  GetTrialbalanceReportDownload() {
    this.PaymentModelSearch.Print = 'XLS';
    this.loadingSearch = true;
    this.spinnerService.show()
    this.PaymentModelSearch.FromDate = this.PaymentModelSearch.FromDate != null && this.PaymentModelSearch.FromDate != '' ? moment(this.PaymentModelSearch.FromDate).format('DD-MMM-YYYY') : '';
    this.PaymentModelSearch.ToDate = this.PaymentModelSearch.ToDate != null && this.PaymentModelSearch.ToDate!='' ? moment(this.PaymentModelSearch.ToDate).format('DD-MMM-YYYY') : '';
  
    this.accService.GetOpeningBalancePost(JSON.stringify(this.PaymentModelSearch)).subscribe((response) => {
      // this.AccountList = response.AccountList;
      this.FilePath = response.FilePath;
      window.location = response.FilePath;
      setTimeout(() => {

        this.loadingSearch = false;
        this.spinnerService.hide()
        this.globalHelper.CheckActionStatus(response);

        this.PaymentModelSearch.Print = '';
      }, 10);
    });
  };



  BranchDetails:any;


  ngOnInit() {

    setTimeout(() => {

      this.PaymentModelSearch.FromDate = moment(this.globalHelper.GetLoginToken().SessionStartDate).format("DD-MMM-YYYY");

      this.PaymentModelSearch.ToDate = moment(this.globalHelper.GetLoginToken().SessionEndDate).format("DD-MMM-YYYY");

    }, 200);
  }
  SessionsList:any;
  SessionList=[];
  GetSession () {
      this.lookupService.GetLookupsList('AcademicSession', '').subscribe((data) =>{
          this.SessionsList = data.LookupItems;
          for (var i = 0; i <this.SessionsList.length; i++) {
            
            if (this.SessionsList[i].ItemId ==0 ||this.SessionsList[i].ItemId > this.globalHelper.GetLoginToken().SessionID) {
              this.SessionList.push(this.SessionsList[i]);
            }

        }
      });
  };

}
